import { ReactElement, useCallback } from 'react';
import { Divider, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import OperatorList from 'front-office/components/shared/operator-list';
import ServiceList from 'front-office/components/released-services/list/service';
import { FormAssignOperatorVM } from 'practice/view-models/practice-assign';

const FormAssignOperator = (): ReactElement => {
  const formContext = useFormikContext<FormAssignOperatorVM>();

  const handleChangeService = useCallback(
    (value) => {
      formContext.setFieldValue('newService', value);
    },
    [formContext.setFieldValue]
  );

  const handleChangeOperator = useCallback(
    (value) => {
      formContext.setFieldValue('newOperator', value);
    },
    [formContext.setFieldValue]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PmiTitleDivider>Attualmente in carico a:</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Servizio"
          aria-label="Servizio"
          name="oldService"
          id="oldService"
          fullWidth
          value={formContext.values.oldService || ''}
          onChange={(event) => formContext.setFieldValue('oldService', event.target.value)}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Operatore"
          aria-label="Operatore"
          name="oldOperator"
          id="oldOperator"
          fullWidth
          value={formContext.values.oldOperator || ''}
          onChange={(event) => formContext.setFieldValue('oldOperator', event.target.value)}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Nuova assegnazione:</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={6}>
        <ServiceList
          required
          value={formContext.values.newService || ''}
          onChange={handleChangeService}
          error={formContext.touched.newService && Boolean(formContext.errors.newService)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <OperatorList
          required
          idService={formContext.values.newService || ''}
          value={formContext.values.newOperator || ''}
          onChange={handleChangeOperator}
          disabled={!formContext.values.newService}
          error={formContext.touched.newOperator && Boolean(formContext.errors.newOperator)}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Motivo Assegnazione Operatore *"
          aria-label="Motivo Assegnazione Operatore"
          id="reason"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '100',
          }}
          value={formContext.values?.reason || ''}
          onChange={(event) => {
            formContext.setFieldValue('reason', event?.target.value);
          }}
          error={formContext.touched.reason && Boolean(formContext.errors.reason)}
          helperText={formContext.errors.reason}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiButton type="submit" variant="outlined" color="cdmBrandThird">
          Conferma
        </PmiButton>
      </Grid>
    </Grid>
  );
};

FormAssignOperator.displayName = 'Practice Assign - Form Assign Operator component';

export default FormAssignOperator;
